/* eslint-disable react-refresh/only-export-components */
import { useLocaleState } from "ra-core";

import { formatLocalizedDate, formatRelativeDate } from "@/lib/formatDateTime";
import type { DateLike } from "@/lib/safeDate";

export { formatLocalizedDate, formatRelativeDate };

export const useRelativeDate = (date: DateLike) => {
  const [locale = "nl"] = useLocaleState();
  return formatRelativeDate(date, locale);
};

export function RelativeDate({ date }: { date: DateLike }) {
  return useRelativeDate(date);
}
